<template>
    <div class="pc-img-explode">
        <div class="motherboard" v-if="activeBuild.motherboard && activeBuild.motherboard.coolers && activeBuild.motherboard.coolers[activeBuild.cpuCooler.id]">
            <a
                :class="getClass('motherboard')"
                href="#tab-motherboard"
                @click.prevent="changeTab('#motherboard-tab-button', '#configure-menu-button', 'motherboard')"
            >
                <img :src="activeBuild.cpuCooler.motherboards[activeBuild.motherboard.id].image" alt="motherboard">
            </a>
        </div>
        <div class="power-supply" v-if="activeBuild.powerSupply">
            <a
                :class="getClass('psu')"
                href="#tab-psu"
                @click.prevent="changeTab('#psu-tab-button', '#configure-menu-button', 'psu')"
            >
                <img :src="activeBuild.powerSupply.render" alt="power-supply">
            </a>
        </div>
        <div class="case" v-if="activeBuild.case">
            <a
                :class="getClass('case')"
                href="#tab-case"
                @click.prevent="changeTab('#cases-tab-button', '#configure-menu-button', 'case')"
            >
                <img :src="activeBuild.case.render" alt="case">
            </a>
        </div>
        <div class="gpu" v-if="activeBuild.gpu">
            <a
                :class="getClass('gpu')"
                href="#tab-gpu"
                @click.prevent="changeTab('#gpu-tab-button', '#configure-menu-button', 'gpu')"
            >
                <img :src="activeBuild.gpu.render" alt="gpu">
            </a>
        </div>
        <div class="rams" v-if="activeBuild.ram">
            <a
                :class="getClass('ram')"
                @click.prevent="changeTab('#ram-tab-button', '#configure-menu-button', 'ram')"
            >
                <template v-for="(quantity, index) in activeBuild.ram.quantity">
                    <img
                        :alt="'ram-' + index"
                        :key="'ram-' + activeBuild.ram.products_id + '-' + index"
                        :src="activeBuild.ram.render"
                    >
                    <img
                        :alt="'ram-2' + index"
                        :key="'ram-2' + activeBuild.ram.products_id + index"
                        :src="activeBuild.ram.render"
                    >
                </template>
            </a>
        </div>
        <div class="fans" v-if="orderedFans && orderedFans.length">
            <a
                :class="getClass('cooling')"
                href="#tab-cooling"
                @click.prevent="changeTab('#cooling-tab-button', '#configure-menu-button', 'cooling')"
            >
                <template v-for="fan in orderedFans">
                    <template v-for="qty in fan.quantity">
                        <img
                            :key="'ram-' + fan.id + '-' + qty"
                            :src="fan.render"
                        >
                    </template>
                </template>
            </a>
        </div>
        <div class="hdd" v-if="activeBuild.hdd && activeBuild.hdd.length">
            <a
                :class="getClass('storage')"
                href="#tab-ssd"
                @click.prevent="changeTab('#storage-tab-button', '#configure-menu-button', 'storage')"
            >
                <template v-for="(disk, index) in activeBuild.hdd">
                    <template v-for="(qty, subIndex) in disk.quantity">
                        <img
                            v-show="disk.render"
                            :alt="'hdd-' + '-' + subIndex + '-' + disk.products_id"
                            :key="'hdd-' + index + '-' + subIndex + '-' + disk.products_id"
                            :src="disk.render"
                        >
                    </template>
                </template>
            </a>
        </div>
        <div class="ssd" v-if="activeBuild.ssd && activeBuild.ssd.length">
            <a
                :class="getClass('storage')"
                href="#tab-ssd"
                @click.prevent="changeTab('#storage-tab-button', '#configure-menu-button', 'storage')"
            >
                <template v-for="(disk, index) in activeBuild.ssd">
                    <template v-for="(qty, subIndex) in disk.quantity">
                        <img
                            v-show="disk.render"
                            :alt="'ssd-' + '-' + subIndex + '-' + disk.products_id"
                            :key="'ssd-' + index + '-' + subIndex + '-' + disk.products_id"
                            :src="disk.render"
                        >
                    </template>
                </template>
            </a>
        </div>
        <template v-for="(extra,index) in activeBuild.extras">
            <div
                v-if="extra.product_class"
                :class="extra.product_class"
                :key="'extra-' + extra.id"
            >
                <a
                    :class="getClass('extras')"
                    href="#tab-extra"
                    @click.prevent="changeTab('#extras-tab-button', '#colors-menu-button', 'extras')"
                >
                    <img
                        v-show="extra.render"
                        :alt="'extra-' + index"
                        :src="extra.render"
                    >
                </a>
            </div>
        </template>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "PcRender",
    computed: {
        ...mapState({
            activeBuild: state => state.Step4.activeBuild,
            activeTab: state => state.Step4.activeTab
        }),
        orderedFans() {
            return _.sortBy(this.activeBuild.caseFans, (fan) => {
                return window.fansOrder.indexOf(fan.products_id);
            });
        }
    },
    methods: {
        ...mapActions(["changeActiveTab", "changeActiveMenu"]),
        changeTab(buttonId, menuId, tabName) {
            $(menuId).click()
            $("#colors-tabs li").removeClass("active");
            $("#configure-tabs li").removeClass("active");
            $(buttonId).click();
            this.changeActiveTab(tabName);
        },
        getClass(partName) {
            if (partName == this.activeTab) {
                return "glow";
            }

            return "";
        }
    }
}
</script>
